import RouteItem from ".";
import Fitness from "../pages/facilities/Fitness";
import Hostel from "../pages/facilities/Hostel";
import Infrastructure from "../pages/facilities/Infrastructure";
import Library from "../pages/facilities/Library";
import OPD from "../pages/facilities/OPD";

// Facilities SubMenu Pages
export const facilitiesRoutes: RouteItem = {
  key: "router-facilities",
  title: "Facilities",
  tooltip: "Facilities",
  path: "/facilities",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-facilities-infrastructure",
      title: "Infrastructure",
      tooltip: "Infrastructure",
      path: "infrastructure",
      enabled: true,
      component: Infrastructure,
      appendDivider: true,
    },
    {
      key: "router-facilities-library",
      title: "Library",
      tooltip: "Library",
      path: "library",
      enabled: true,
      component: Library,
      appendDivider: true,
    },
    {
      key: "router-facilities-hostel",
      title: "Hostel",
      tooltip: "Hostel",
      path: "hostel",
      enabled: true,
      component: Hostel,
      appendDivider: true,
    },
    {
      key: "router-facilities-opd",
      title: "OPD",
      tooltip: "OPD",
      path: "opd",
      enabled: true,
      component: OPD,
      appendDivider: true,
    },
    {
      key: "router-facilities-fitness",
      title: "Fitness",
      tooltip: "Fitness",
      path: "fitness",
      enabled: true,
      component: Fitness,
      appendDivider: true,
    },
  ],
};
